/*
 * authService
 */

import { AuthService } from 'app/_services/auth.service';

export function authServiceFactory(i: any) {
    return i.get('authService');
}

export const authServiceProvider = {
    provide: AuthService,
    useFactory: authServiceFactory,
    deps: ['$injector']
};

/*
 * utilService
 */

import { UtilService } from 'app/_services/util.service';

export function utilServiceFactory(i: any) {
    return i.get('utilService');
}

export const utilServiceProvider = {
    provide: UtilService,
    useFactory: utilServiceFactory,
    deps: ['$injector']
};
